import { PermissionsList } from '@modules/permissions/constants';
import { Permission } from '@modules/permissions/utils';

export const TRANSLATION_GROUP_AFFILIATE_REFERENCE = Symbol('affiliate.reference');
export const AFFILIATE_REFERENCE_ROUTE_NAME = Symbol('affiliate.reference');
export const AFFILIATE_REFERENCE_CONDITION_ROUTE_NAME = Symbol('affiliate.subaffiliate-condition');
export const AFFILIATE_REFERENCE_LINK_ROUTE_NAME = Symbol('affiliate.subaffiliate-condition.link');

export const AFFILIATE_REFERENCE_QUERY_KEY = 'affiliate-referrals-token';
export const AFFILIATE_REFERENCE_API_URL = 'affiliate/settings/referrals_token';

export const AFFILIATE_REFERENCE_CONDITION_QUERY_KEY = 'affiliate-referrals-condition';
export const AFFILIATE_REFERENCE_CONDITION_API_URL = 'affiliate/settings/show_subaffiliate_condition';

export const AFFILIATE_REFERENCE_PERMISSIONS = {
  SHOW: new Permission(undefined, PermissionsList.affiliate.SETTINGS_REFERRALS_TOKEN),
};
